import React from 'react';
import styled from 'styled-components';

import HeaderMenu from './HeaderMenu';

import logoLight from 'images/logo-light.png';
import logoDark from 'images/logo-dark.png';
import NavigationColor from 'utils/constants/NavigationColor';
import { Link, useTranslation } from 'gatsby-plugin-react-i18next';
import Button from 'components/Button';
import { breakpoints } from 'theme';

const StyledHeader = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 180px 0 180px;

  .desktopLogo {
    display: flex;
  }

  @media (max-width: ${breakpoints.tablet}) {
    display: none;
  }
`;

const FlexWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 40px;

  @media (max-width: ${breakpoints.tablet}) {
    display: none;
  }
`;

interface Props {
  variant: NavigationColor.LIGHT | NavigationColor.DARK;
}

const Header = ({ variant }: Props) => {
  const { t } = useTranslation();

  return (
    <StyledHeader>
      <Link className="desktopLogo" to="/">
        <img
          src={variant === NavigationColor.LIGHT ? logoLight : logoDark}
          alt="SafeBrok logo"
        />
      </Link>
      <FlexWrapper>
        <HeaderMenu variant={variant} />
        <Button href="/contact">{t('home.contact_us.cta_button')}</Button>
      </FlexWrapper>
    </StyledHeader>
  );
};

export default Header;
